import type { Product } from '@/api/products';

export interface DirectSaleSize {
  id: string;
  name: string;
}

/**
 * The sizes the Direct Sale offers for a colour: those a sellable variant
 * of that colour carries, once each, in catalogue order. The quote refuses
 * any other size (400 quote_size_unknown), so offering it would leave the
 * customer stuck. Without a colour (a colourless product) every size
 * counts, as the quote then filters by size alone.
 */
export function sizesForColor(
  product: Pick<Product, 'variants'> | null | undefined,
  colorId: string | null
): DirectSaleSize[] {
  const seen = new Map<string, string>();
  for (const variant of product?.variants ?? []) {
    if (!variant.productSizeId || seen.has(variant.productSizeId)) continue;
    if (colorId && variant.productColorId !== colorId) continue;
    // The catalogue sends available variants only; a discontinued one
    // cannot be sold either.
    if (variant.isAvailable === false || variant.isDiscontinued === true) {
      continue;
    }
    seen.set(variant.productSizeId, variant.productSize?.name ?? '');
  }
  return Array.from(seen, ([id, name]) => ({ id, name }));
}
